export const it = {
  common: {
    ctaLabel: "Facciamo due chiacchiere",
    freeNote: "15 minuti di consulenza gratuita.",
  },
  header: {
    backToTop: "Torna in cima",
    logoAlt: "Fra un viaggio e l’altro — Francesca Zaccari, travel designer",
    logoAltShort: "Fra un viaggio e l’altro",
    mainNavAria: "Navigazione principale",
    mobileNavAria: "Navigazione mobile",
    openMenu: "Apri il menu",
    closeMenu: "Chiudi il menu",
    languageLabel: "Cambia lingua",
    nav: {
      about: "Chi sono",
      services: "Servizi",
      itineraries: "Itinerari",
      how: "Come funziona",
      reviews: "Recensioni",
    },
  },
  hero: {
    eyebrow: "Travel Designer · Accompagnatrice Turistica",
    greetingBefore: "Ciao, mi chiamo ",
    greetingAccent: "Francesca",
    titleBefore: "Il tuo viaggio",
    titleAccent: "attraverso l’arte.",
    paragraph:
      "Mi chiamo Francesca, sono una Travel Designer e costruisco itinerari su misura che leggono un luogo attraverso la sua arte e la sua storia. Niente pacchetti “preconfezionati”, solo viaggi che ti lasciano qualcosa.",
    paragraphMobile:
      "Sono una Travel Designer e costruisco itinerari su misura che leggono un luogo attraverso la sua arte e la sua storia. Niente pacchetti “preconfezionati”, solo viaggi che ti lasciano qualcosa.",
    colosseumAlt: "Il Colosseo a Roma al tramonto",
    positanoAlt: "Le case colorate di Positano affacciate sul mare",
    polaroidCaption: "Costiera Amalfitana",
    badge: "viaggi d’arte nel mondo",
    girlAlt: "Illustrazione di una viaggiatrice con sciarpa arancione e un libro d’arte in mano",
  },
  about: {
    eyebrow: "Chi sono",
    titleBefore: "Sono Francesca,",
    titleAccent: "storica dell’arte in viaggio.",
    p1: "Ho studiato all’Università di Bologna, dove ho preso due lauree: Beni Culturali e Arti Visive. In pratica, ho passato anni a imparare a guardare le città come si guarda un quadro, e non ho più smesso.",
    p2: "Dopo la laurea ho vissuto un anno in Canada, poi sono tornata e ho fatto il corso da Travel Designer a Milano: lì ho imparato il mestiere di costruire itinerari su misura, pezzo per pezzo. A Ravenna ho preso il patentino da Accompagnatrice Turistica.",
    p3Before:
      "Oggi lavoro come accompagnatrice nei food tour per diverse agenzie e accompagno gruppi all’estero.",
    p3Brand: "Fra un viaggio e l’altro",
    p3After:
      "è il mio progetto personale: giovane e fatto con cura, proprio come gli itinerari che disegno su misura.",
    portraitAlt: "Francesca Zaccari, travel designer e accompagnatrice turistica",
    portraitMissing: "la foto arriva presto",
    mapAlt: "Mappa di viaggio con appunti e itinerari segnati a mano",
    mapCaption: "appunti di rotta",
    badgeAria: "Travel Designer Certificata",
    steps: [
      { place: "Bologna", text: "Due lauree in Beni Culturali e Arti Visive" },
      { place: "Canada", text: "Un anno di vita all’estero dopo la laurea" },
      { place: "Milano", text: "Corso da Travel Designer: itinerari su misura" },
      { place: "Ravenna", text: "Patentino da Accompagnatrice Turistica" },
    ],
  },
  concept: {
    eyebrow: "Il concept",
    titleBefore: "Non un pacchetto.",
    titleAccent: "Un punto di vista.",
    paragraph:
      "Unisco viaggio, arte e cultura: ogni itinerario racconta un luogo attraverso una chiave artistica o storica. Non una lista di cose da vedere, ma una storia da attraversare con tempi giusti, contesto e qualche deviazione che vale il viaggio.",
    points: [
      {
        title: "Itinerari culturali e artistici",
        text: "Ogni viaggio ha una chiave di lettura: un artista, un’epoca, un movimento.",
      },
      {
        title: "Per viaggiatori internazionali e gruppi",
        text: "Penso e accompagno percorsi per chi arriva da lontano e per chi viaggia insieme.",
      },
      {
        title: "Metodo da storica dell’arte",
        text: "Fonti, contesti, dettagli: la stessa cura con cui si studia un’opera.",
      },
    ],
    badge: "esempio di itinerario",
    cardTitle: "Sulle tracce di Caravaggio",
    cardText:
      "Un itinerario tra Roma e Napoli per esplorare le due città con gli occhi del pittore: le tele nelle chiese, le strade che ha attraversato, la luce che ha cambiato la pittura.",
    cardMeta: "Roma → Napoli · arte · storia",
    galleryAlt: "Interno di una galleria d’arte italiana con dipinti alle pareti",
    cinqueTerreAlt: "I borghi colorati delle Cinque Terre affacciati sul mare",
    discoverCta: "Scopri di più",
  },
  services: {
    eyebrow: "Servizi",
    titleBefore: "Cosa posso fare",
    titleAccent: "per te",
    items: [
      {
        title: "Travel Design",
        description:
          "Un itinerario di viaggio completamente personalizzato, costruito su misura in base a chi sei, cosa ti interessa e come ti piace viaggiare. Niente pacchetti preconfezionati: studio tappe, tempi ed esperienze per te. Le prenotazioni dei servizi passano poi tramite agenzia, tu non devi pensare a nulla.",
      },
      {
        title: "Accompagnamento turistico",
        description:
          "Oltre a disegnare l’itinerario, posso accompagnare fisicamente te o il tuo gruppo, in Italia e all’estero. Musei, città d’arte, percorsi fuori dalle rotte battute, cultura gastronomica: viaggio con te e mi assicuro che la logistica del viaggio funzioni.",
      },
      {
        title: "Revisione itinerario",
        description:
          "Hai già un piano di viaggio? Lo guardo con occhi da esperta e ti dico con franchezza cosa funziona, cosa no e cosa manca: tappe troppo tirate, orari che non tornano, perle che rischi di perderti a due passi da dove sarai.",
      },
      {
        title: "Guide di viaggio",
        description:
          "Contenuti e risorse di viaggio da leggere fra un viaggio e l’altro: guide, consigli pratici e approfondimenti d’arte per arrivare preparato e guardare ogni luogo con altri occhi.",
      },
    ],
    bottomText: "Non sai da dove partire?",
    discoverCta: "Scopri i servizi",
  },
  servicesPage: {
    eyebrow: "I servizi in dettaglio",
    titleBefore: "Quattro modi di viaggiare",
    titleAccent: "con me.",
    intro:
      "Ogni viaggio è diverso, e ogni viaggiatore ha bisogno di qualcosa di diverso: c’è chi vuole un itinerario costruito da zero, chi una guida al proprio fianco, chi solo un secondo parere. Qui trovi nel dettaglio cosa posso fare per te — con un esempio concreto per ciascun servizio.",
    exampleLabel: "Un esempio concreto",
    idealForLabel: "Per chi è",
    items: [
      {
        example:
          "Una settimana a Parigi sulle tracce degli Impressionisti: il Musée d’Orsay al mattino presto, lontano dalla folla; una passeggiata a Montmartre, dove questi pittori vivevano e lavoravano; una giornata a Giverny, tra i giardini di Monet. Ritmo rilassato, con il tempo giusto per i caffè storici e le librerie della Rive Gauche.",
        idealFor: "Per chi vuole un viaggio costruito su misura, senza pensare a nulla.",
      },
      {
        example:
          "Tre giorni a Firenze con un gruppo di amici: gli Uffizi raccontati con calma, sala per sala; l’Oltrarno degli artigiani, lontano dai percorsi più battuti; un tramonto da un punto panoramico che non trovi sulle guide. Io viaggio con voi e vi racconto quello che vediamo, da storica dell’arte.",
        idealFor: "Per gruppi, famiglie e viaggiatori che vogliono una guida esperta al proprio fianco.",
      },
      {
        example:
          "Avevi pianificato Roma in due giorni con otto tappe al giorno? Lo ricalibro insieme a te: elimino le corse inutili, riordino le visite per zona e inserisco quella chiesa con due Caravaggio che rischiavi di perderti a due passi dal tuo hotel.",
        idealFor: "Per chi ha già un piano di viaggio ma vuole uno sguardo esperto prima di partire.",
      },
      {
        example:
          "Una guida digitale su misura prima della partenza: cosa vedere e in che ordine, come muoverti, dove mangiare e le chiavi di lettura d’arte per ogni tappa — da consultare offline, direttamente dal telefono.",
        idealFor: "Per i viaggiatori indipendenti che vogliono partire preparati.",
      },
    ],
    ctaTitle: "Non sai quale fa per te?",
    ctaSubtitle:
      "Raccontamelo in una chiacchierata gratuita di 15 minuti: capiamo insieme da dove partire.",
    backHome: "Torna alla home",
  },
  itinerariesPage: {
    eyebrow: "Itinerari di viaggio artistici-culturali",
    titleBefore: "Viaggi con",
    titleAccent: "un punto di vista.",
    intro: "Questi sono esempi di itinerari che posso costruire e personalizzare insieme a te.",
    detailsLabel: "L’esperienza",
    durationLabel: "Durata indicativa",
    backHome: "Torna alla home",
    closeModalAria: "Chiudi dettagli itinerario",
    itineraryLabel: "Itinerario",
    discoverMore: "Scopri di più",
    ctaEyebrow: "Costruiamo il tuo viaggio",
    ctaTitle: "Hai già una destinazione in mente?",
    ctaText: "Partiamo dai tuoi desideri e trasformiamoli in un itinerario su misura.",
    items: [
      { title: "Caravaggio tra Roma e Napoli", description: "Chiese, piazze e capolavori raccontati attraverso la luce e la storia del pittore.", details: "Un percorso che parte da Roma e ci mostra gli inizi del pittore tra i Musei Capitolini, le chiese e Galleria Borghese, per poi arrivare a Napoli, dove Caravaggio si sente finalmente compreso.", duration: "5 giorni", cover: "/images/caravaggio-giuditta.jpg", coverAlt: "Giuditta che taglia la testa di Oloferne, Caravaggio" },
      { title: "Impressionisti in Provenza", description: "Da Cézanne a Van Gogh, la Provenza e i suoi campi di lavanda in fiore visti attraverso i loro occhi.", details: "Un itinerario tra le città che hanno ispirato i grandi maestri dell'impressionismo, per leggere un paesaggio che ha cambiato il modo di vedere l'arte.", duration: "5-7 giorni", cover: "/uploads/eabb27de4d.jpg", coverAlt: "Campo di grano con vista di Saint-Rémy, Van Gogh" },
      { title: "Sulle orme dell’abbazia di Pomposa", description: "Tre itinerari di un giorno, un unico filo conduttore: l’abbazia di Pomposa, faro di fede e cultura nel medioevo tra il Po e il mare.", details: "1 · Giotto tra Padova e Pomposa\nDa Padova, tra la Cappella degli Scrovegni e la Basilica del Santo, fino a Pomposa: sulle tracce delle influenze del pittore lungo la riviera romagnola.\n\n2 · Il mosaico tra Ravenna e Pomposa\nSi parte dai mosaici bizantini e paleocristiani di Ravenna e da Sant’Apollinare in Classe, per arrivare a Pomposa davanti alla pavimentazione musiva medievale: un percorso che chiude un cerchio aperto secoli prima.\n\n3 · Dante, l’esilio e gli ultimi giorni\nDa Ravenna, nei luoghi che lo accolsero durante la stesura della Commedia, fino a Pomposa, dove conobbe il suo personale inferno: qui si ammala e di lì a poco morirà.", duration: "3 itinerari · 1 giorno ciascuno", cover: "/uploads/252221080f.jpg", coverAlt: "Interno della basilica con affreschi medievali" },
      { title: "Firenze rinascimentale", description: "La città dei Medici letta attraverso artisti, botteghe e architetture.", details: "Uffizi, Oltrarno, cappelle e laboratori artigiani con tempi equilibrati e pause nei luoghi giusti.", duration: "2–4 giorni", cover: "/uploads/e89d5c2b97.jpg", coverAlt: "Panorama di Firenze con il Duomo" },
      { title: "Venezia tra arte e acqua", description: "Una Venezia da attraversare con curiosità, tra grandi capolavori e dettagli nascosti.", details: "San Marco, Dorsoduro, isole della laguna e itinerari alternativi per scoprire la città senza fretta.", duration: "3 giorni", cover: "/images/venezia.jpg", coverAlt: "Un canale di Venezia" },
      { title: "Cinque Terre oltre la cartolina", description: "Borghi, sentieri e paesaggi liguri con un ritmo lento e consapevole.", details: "Un itinerario tra mare, cultura locale e piccoli produttori, lontano dalle tappe più affollate.", duration: "3–5 giorni", cover: "/images/cinque-terre.jpg", coverAlt: "I borghi colorati delle Cinque Terre" },
    ],
  },
  collaborations: {
    navLabel: "Collaborazioni",
    eyebrow: "Collaborazioni",
    titleBefore: "Le realtà che",
    titleAccent: "viaggiano con me.",
    intro:
      "Oltre ai viaggi su misura, lavoro con tour operator e realtà locali che condividono il mio modo di viaggiare. Qui trovi tutti i tour e i gruppi con cui parto, prenotabili direttamente con loro.",
    backHome: "Torna alla home",
    homeEyebrow: "Collaborazioni",
    homeTitleBefore: "Viaggio anche",
    homeTitleAccent: "in compagnia.",
    homeText:
      "Food tour in Emilia-Romagna, tour in gruppo per l’Italia e per il mondo, coordinatrice di viaggio: alcune delle mie partenze sono prenotabili direttamente con le realtà con cui collaboro.",
    homeCta: "Scopri le collaborazioni",
    foodTours: {
      title: "Food tour",
      role: "Accompagnatrice turistica",
      intro:
        "Il cibo è cultura: accompagno food tour in Emilia-Romagna, tra mercati storici, botteghe e tavole imbandite. Ogni tour è prenotabile direttamente con l’organizzazione.",
      partners: [
        {
          place: "Rimini · con Hili",
          text: "A Rimini cammino con Hili tra le tappe del centro storico: pasta fresca, piadina e le storie della città, in un tour che unisce gusto e curiosità.",
          code: "",
          codeLabel: "",
          links: [
            { label: "Get Your Guide", url: "https://gyg.me/GOCSOAtk" },
            { label: "Viator", url: "https://www.viator.com/it-IT/tours/Rimini/Rimini-Walking-Food-Tour-and-Highlights/d30027-326991P39" },
          ],
        },
        {
          place: "Bologna · con Do Eat Better",
          text: "A Bologna guido il tour gastronomico di Do Eat Better Experience: i sapori della città raccontati tra le bancarelle del mercato e le botteghe del centro. Con il mio codice hai il 5% di sconto.",
          code: "FRANCIZ5BOLOGNA",
          codeLabel: "Codice sconto 5%: ",
          links: [
            { label: "Do Eat Better Experience", url: "https://doeatbetterexperience.com/italy-food-tour/what-to-do-in-bologna/bologna-food-tour/" },
          ],
        },
        {
          place: "Bologna · con Tours and The City",
          text: "Con Tours and The City guido la Bologna Gastronomic Experience: mercati storici, botteghe e ricette della tradizione raccontate a tavola.",
          code: "",
          codeLabel: "",
          links: [
            { label: "Tours and The City", url: "https://toursandthecity.com/bologna-gastronomic-experience-with-a-local/" },
          ],
        },
        {
          place: "Bologna · con Taste Bologna",
          text: "Con Taste Bologna accompagno il Classic Bologna Food Tour: osterie storiche, mercati e botteghe di famiglia, tra parmigiano, mortadella e tortellini fatti a mano, in piccoli gruppi.",
          code: "",
          codeLabel: "",
          links: [
            { label: "Taste Bologna", url: "https://www.tastebologna.net/classic-bologna" },
          ],
        },
      ],
    },
    village: {
      title: "The Village",
      role: "Accompagnatrice turistica",
      text: "Per The Village accompagno i tour in Emilia-Romagna, con partenze da Bologna e Ravenna: viaggi brevi e curati alla scoperta delle meraviglie della regione.",
      linkLabel: "The Village Italy",
      url: "https://www.thevillageitaly.com/",
    },
    realWanderlust: {
      title: "Real Wanderlust",
      role: "coordinatrice di viaggi di gruppo",
      text: "Accompagno i viaggi di gruppo di Real Wanderlust in tutto il mondo, tra itinerari curati e spirito libero.",
      linkLabel: "Real Wanderlust",
      url: "https://www.realwanderlust.it/",
    },
    theVoyage: {
      title: "The Voyage",
      role: "Esperta locale di Bologna",
      text: "Con The Voyage racconto Bologna ai viaggiatori che arrivano da tutto il mondo: tour tra i portici, il mercato e le storie di una delle città più belle d’Italia.",
      linkLabel: "Il mio profilo su The Voyage",
      url: "https://www.thevoyage.co/locals/francesca-zaccari",
    },
    aurea: {
      title: "Aurea Viaggi",
      role: "Accompagnatrice turistica",
      text: "Con Aurea Viaggi accompagno i viaggi di gruppo a passo lento: mete d\u2019arte e natura vissute con calma, con tempi comodi e racconti curati, pensati per chi preferisce assaporare ogni tappa senza correre.",
      linkLabel: "Aurea Viaggi",
      url: "https://aureaviaggicastenaso.my.canva.site/",
      tour: {
        eyebrow: "Prossimo tour",
        title: "La Cascata delle Marmore a tema acqua",
        text: "Dal 9 all\u201911 aprile 2027 esploriamo insieme la Cascata delle Marmore, celebrata dai poeti attraverso l\u2019acqua: terra, arte e natura.",
        email: "fra.unviaggioelaltro@gmail.com",
        emailSubject: "Tour Cascata delle Marmore \u2014 Aurea Viaggi, 9-11 aprile",
        emailLabel: "Per pi\u00f9 informazioni scrivimi",
      },
    },
    weroad: {
      title: "WeRoad",
      role: "Coordinatrice di viaggio di gruppo",
      text: "Su WeRoad parto come coordinatrice di viaggio: gruppi di coetanei, itinerari pensati per vivere la destinazione insieme e un pizzico di avventura.",
      linkLabel: "Prossime partenze",
      url: "https://www.weroad.it/coordinatori/francesca-zaccari",
    },
  },
  process: {
    eyebrow: "Il percorso",
    titleBefore: "Come",
    titleAccent: "funziona",
    steps: [
      {
        title: "Ci conosciamo",
        description:
          "Quindici minuti di consulenza gratuita: mi racconti dove vuoi andare, cosa ami e come viaggi. Nessun impegno, serve a capire se posso esserti utile.",
      },
      {
        title: "Disegno il tuo viaggio",
        description:
          "Costruisco l’itinerario su misura: tappe, esperienze, ritmi. Niente copia-incolla, ogni viaggio parte da zero e da chi lo farà.",
      },
      {
        title: "Si parte",
        description:
          "L’itinerario è pronto. Le prenotazioni dei servizi passano tramite agenzia, tu pensi solo a fare la valigia e partire.",
      },
    ],
  },
  reviews: {
    eyebrow: "Recensioni",
    titleBefore: "Parole di chi ha viaggiato",
    titleAccent: "con me",
    prevAria: "Recensione precedente",
    nextAria: "Prossima recensione",
    goToAria: "Vai alla recensione {n}",
    items: [
      {
        name: "Noemi G.",
        initial: "N",
        trip: "Budapest, 3 giorni su misura",
        text: "Francesca è riuscita a venire incontro alle mie esigenze. Dopo aver deciso insieme quali attrazioni e luoghi iconici di Budapest visitare, ha creato un itinerario su misura di 3 giorni. I diversi cambiamenti fatti in corso d’opera per necessità (come ad esempio invertire qualche visita fra il secondo ed il terzo giorno), non hanno rovinato l’esperienza. Anzi, mi hanno permesso di seguire i miei ritmi, facendomi godere al massimo la capitale.",
      },
      {
        name: "Giulia Z.",
        initial: "G",
        trip: "Tour d’Irlanda in preparazione",
        text: "Vivo a Dublino da 11 mesi ormai ma non ho mai avuto la possibilità di visitare meglio l’Irlanda. Così mi sono affidata a Francesca, che sta organizzando un tour in base alle mie esigenze e preferenze. Mi tiene aggiornata sui vari cambiamenti e aggiornamenti. Ha capito esattamente che tipo di esperienza vorrei vivere e sta pianificando il tutto con grande passione e impegno. A questo punto non vedo l’ora di visitare tutti i posti che Francesca avrà scovato tra i paesaggi affascinanti dell’Irlanda.",
      },
      {
        name: "Soana G.",
        initial: "S",
        trip: "Preventivo dettagliato",
        text: "Devo fare i complimenti a Francesca perché il suo preventivo è stato molto dettagliato e curato nei minimi dettagli... Molto molto brava, la consiglio a tutti quelli che desiderano fare un viaggio perché lei cerca di esaudire il tuo sogno facendo sì che il viaggio sia un'esperienza unica.",
      },
      {
        name: "Luca C.",
        initial: "L",
        trip: "Vietnam e Filippine, revisione itinerario",
        text: "Ho fatto la consulenza gratuita con Francesca per poi decidere di fare la revisione dell'itinerario. Nonostante il mio viaggio in Vietnam e Filippine fosse organizzato molto all'ultimo, con spostamenti e hotel presi pochi giorni prima di partire, è riuscita a riorganizzare l'itinerario al meglio e siamo riusciti a vedere tutto quello che volevamo nella maniera più ottimale. La sua consulenza è stata necessaria per le coincidenze dei voli e in base a quella abbiamo capito come muoverci.",
      },
      {
        name: "Marica D.",
        initial: "M",
        trip: "Bologna, tour di città con accompagnamento",
        text: "Ho avuto modo di conoscere Francesca già durante un viaggio di gruppo ad agosto e, dopo quella prima esperienza, ho avuto il piacere di ritrovarla come accompagnatrice alla scoperta di Bologna, mentre io ero qui per lavoro. È stata una bellissima esperienza: Francesca mi ha accompagnato tra i principali punti di interesse della città, raccontandomi le sue curiosità con passione e competenza. La visita è stata piacevole e mai banale, anche grazie al suo modo di fare molto disponibile e alla sua capacità di mettere a proprio agio. Non è mancata naturalmente la parte gastronomica: abbiamo avuto modo di assaggiare diverse specialità della cucina bolognese, che hanno reso la giornata ancora più completa e autentica. È stato davvero un piacere trascorrere del tempo con Francesca e scoprire Bologna attraverso i suoi racconti e il suo punto di vista. Una persona preparata, solare e appassionata, che consiglio assolutamente a chiunque voglia conoscere Bologna non solo come turista, ma anche attraverso le sue storie, le sue tradizioni e la sua cucina.",
      },
    ],
  },
  ctaBand: {
    title: "Hai un viaggio in testa?",
    subtitle: "Raccontamelo in una consulenza gratuita di 15 minuti.",
  },
  finalCta: {
    quote:
      "[…] Sotto l’azzurro fitto del cielo qualche uccello di mare se ne va; né sosta mai: perché tutte le immagini portano scritto: «più in là».",
    titleBefore: "Prontə a partire?",
    titleAccent: "Il tuo viaggio inizia da qui.",
    subtext: "Nessun impegno di acquisto.",
    polaroidCaption: "Nuovi punti di vista",
    positanoAlt: "Un panorama mozzafiato scoperto in viaggio",
    veneziaAlt: "Un canale di Venezia al tramonto",
  },
  privacy: {
    backLink: "Torna alla home",
    seoTitle: "Privacy Policy — Fra un viaggio e l’altro",
    title:
      "INFORMATIVA PER IL TRATTAMENTO DEI DATI PERSONALI AI SENSI DELL’ARTICOLO 13 DEL REGOLAMENTO UE 2016/679",
    intro:
      "La presente Privacy Policy descrive le modalità con cui Fra un viaggio e l’altro raccoglie, utilizza, protegge e condivide i dati personali degli utenti che visitano il sito web www.fraunviaggioelaltro.it, nel pieno rispetto del Regolamento UE 2016/679 (GDPR) e della normativa italiana in materia di protezione dei dati personali.",
    sections: [
      {
        heading: "Titolare del trattamento",
        paragraphs: ["Il Titolare del trattamento dei dati è:"],
        bullets: [
          "Fra un viaggio e l’altro",
          "Francesca Zaccari",
          "fra.unviaggioelaltro@gmail.com",
        ],
        outro: "",
      },
      {
        heading: "Tipologie di dati raccolti",
        paragraphs: [
          "Durante la navigazione e/o l’utilizzo dei servizi offerti dal sito, possiamo raccogliere le seguenti categorie di dati:",
        ],
        bullets: [
          "Dati identificativi: nome, cognome, email, numero di telefono (es. modulo di contatto o richiesta informazioni).",
          "Dati di navigazione: indirizzo IP, tipo di browser, dati relativi alla sessione, pagine visitate (tramite cookie tecnici o analitici).",
          "Dati forniti volontariamente: messaggi, commenti, recensioni, prenotazioni, iscrizione alla newsletter.",
        ],
        outro: "",
      },
      {
        heading: "Finalità del trattamento",
        paragraphs: ["I dati personali raccolti sono trattati per le seguenti finalità:"],
        bullets: [
          "Rispondere a richieste inviate tramite il modulo di contatto;",
          "Fornire informazioni o preventivi su viaggi e servizi turistici;",
          "Iscrivere l’utente alla newsletter (previo consenso);",
          "Migliorare l’esperienza utente e le funzionalità del sito;",
          "Adempiere ad obblighi legali o fiscali.",
        ],
        outro: "",
      },
      {
        heading: "Base giuridica del trattamento",
        paragraphs: ["Il trattamento dei dati si basa su:"],
        bullets: [
          "Consenso espresso dall’interessato (es. iscrizione alla newsletter);",
          "Esecuzione di misure precontrattuali o contrattuali (es. richiesta di preventivo o informazioni);",
          "Obblighi di legge a cui è soggetto il Titolare;",
          "Legittimo interesse del Titolare, nel caso di analisi statistiche anonime per migliorare i servizi.",
        ],
        outro: "",
      },
      {
        heading: "Modalità del trattamento",
        paragraphs: [
          "Il trattamento dei dati avviene in modo lecito, corretto e trasparente, tramite strumenti manuali e informatici. Sono adottate misure tecniche e organizzative adeguate per garantire la sicurezza e la riservatezza dei dati, evitando accessi non autorizzati, perdite o divulgazioni.",
        ],
        bullets: [],
        outro: "",
      },
      {
        heading: "Comunicazione e diffusione dei dati",
        paragraphs: ["I dati personali non saranno mai diffusi a terzi, salvo nei seguenti casi:"],
        bullets: [
          "Soggetti che forniscono servizi per conto del Titolare (es. web hosting, gestione newsletter, consulenti informatici);",
          "Obblighi di legge, autorità giudiziarie o pubbliche amministrazioni;",
          "Collaboratori o partner strettamente legati alla gestione dei servizi proposti (es. agenzie di viaggio o tour operator).",
        ],
        outro:
          "Tutti i soggetti esterni che trattano i dati per conto del Titolare sono nominati Responsabili del trattamento e garantiscono adeguate misure di protezione.",
      },
      {
        heading: "Conservazione dei dati",
        paragraphs: [
          "I dati saranno conservati per il tempo strettamente necessario a conseguire le finalità indicate, salvo diversi obblighi di legge. In particolare:",
        ],
        bullets: [
          "Dati di contatto: fino all’evasione della richiesta o alla revoca del consenso;",
          "Dati per newsletter: fino alla disiscrizione;",
          "Dati di navigazione: secondo le tempistiche definite nella Cookie Policy.",
        ],
        outro: "",
      },
      {
        heading: "Diritti dell’interessato",
        paragraphs: [
          "Ai sensi degli articoli 15-22 del GDPR, l’utente può esercitare in qualsiasi momento i seguenti diritti:",
        ],
        bullets: [
          "Accesso ai propri dati personali;",
          "Rettifica o aggiornamento;",
          "Cancellazione (“diritto all’oblio”);",
          "Limitazione del trattamento;",
          "Opposizione al trattamento;",
          "Portabilità dei dati;",
          "Revoca del consenso (senza pregiudicare la liceità del trattamento precedente);",
          "Reclamo all’Autorità Garante per la Protezione dei Dati Personali.",
        ],
        outro:
          "Per esercitare i propri diritti, è possibile inviare una richiesta all’indirizzo email fra.unviaggioelaltro@gmail.com.",
      },
      {
        heading: "Trasferimento dei dati al di fuori dell’UE",
        paragraphs: [
          "Di norma i dati non vengono trasferiti al di fuori dello Spazio Economico Europeo. In caso di necessità, il trasferimento avverrà nel rispetto delle garanzie previste dal GDPR (es. decisioni di adeguatezza, clausole contrattuali standard).",
        ],
        bullets: [],
        outro: "",
      },
      {
        heading: "Cookie Policy",
        paragraphs: [
          "Questo sito utilizza cookie tecnici e, previo consenso, anche cookie di profilazione o analitici. Per maggiori informazioni e per gestire le preferenze, si invita a consultare la Cookie Policy dedicata.",
        ],
        bullets: [],
        outro: "",
      },
      {
        heading: "Modifiche alla presente informativa",
        paragraphs: [
          "Fra un viaggio e l’altro si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento, pubblicando la versione aggiornata sul sito. Gli utenti sono invitati a consultare regolarmente questa pagina.",
        ],
        bullets: [],
        outro: "",
      },
    ],
  },
  notFound: {
    title: "Pagina non trovata",
    message: "La pagina {path} non esiste.",
    goHome: "Torna alla home",
    goBack: "Torna indietro",
  },
  footer: {
    privacyLink: "Privacy Policy",
    logoAlt: "Fra un viaggio e l’altro — logo",
    copyright:
      "© {year} Fra un viaggio e l’altro · Francesca Zaccari — Travel Designer & Accompagnatrice Turistica · P. IVA 02803860390",
  },
}

export type Translations = typeof it
